var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.matchHolderClass},[_c('div',{staticClass:"match-card-line-back"}),_c('MatchInfo',{attrs:{"matchdata":_vm.matchdata,"hidematchname":_vm.hidematchname}}),_c('div',{class:{'match-card-line-top':this.index === 0, 'match-card-line-bottom':this.index === 1 }})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }